module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"msg":["Most Active by Value","Most Active by Volume","Gainers","Losers"]},"ar":{"msg":["الأكثر تداولا حسب القيمة","الأكثر تداولا حسب الحجم","الأكثر إرتفاعا","الأكثر إنخفاضا"]}}')
  delete Component.options._Ctor
}
